import { useTranslation } from "react-i18next";

import { DetailsPanelComment } from "#modules/quoteRequestLines/views/DetailsPanel/DetailsPanelComment";

export const DetailsPanelComments = ({ quoteRequestLineId }: { quoteRequestLineId: string }) => {
  const { t } = useTranslation();

  return (
    <>
      <DetailsPanelComment
        label={t("quoteRequestLine.comment")}
        accessor="comment"
        quoteRequestLineId={quoteRequestLineId}
      />
      <DetailsPanelComment
        label={t("quoteRequestLine.internalComment")}
        accessor="internalComment"
        quoteRequestLineId={quoteRequestLineId}
      />
    </>
  );
};
